<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row :gutter="16">
          <Col span="19">
            <Button type="primary" @click="modal1=true;detail={};genRandom()">增加资讯
            </Button>
          </Col>


          <Col span="5">
            <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key" @on-search="reload"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" border style="width: 100%">
        <el-table-column prop="id" label="编号" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="title" :label="'标题'" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="zhaiyao" label="摘要" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="dz" label="点赞量" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="fx" label="分享量" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="yd" label="阅读量" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="time" label="发布时间" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="" label="海报推荐课程" width="160"  :show-tooltip-when-overflow="true">
          <template slot-scope="scope">

            {{ scope.row.cids }}
            <cite>|</cite>
            <a @click="open3(scope.row)">设置</a>
          </template>
        </el-table-column>

        <el-table-column prop="msg" label="操作" width="170" fixed="right">
          <template slot-scope="scope">
            <a :href="'/api/article/showPoster?id='+scope.row.id" target="_blank">预览海报</a>
            <cite>|</cite>
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange" show-elevator @on-change="change"
            show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
        v-model="modal1"
        title="增加或编辑"
        :mask-closable="false"
        @on-ok="save">
      <Form :label-width="100">

        <FormItem label="标题" required>
          <Input v-model="detail.title"/>
        </FormItem>
        <FormItem label="内容" required>
          <JsonInput v-model="detail.content"></JsonInput>
        </FormItem>
        <FormItem label="摘要" required>
          <Input type="textarea" v-model="detail.zhaiyao" :rows="{minRows:10}"/>
          <p>摘要会在列表中展示，一般写80个字即可</p>
          <p>内容改变后会自动同步到摘要，摘要改变不会同步到内容</p>
        </FormItem>

        <Divider>以下信息系统自动生成或选填项</Divider>

        <FormItem label="点赞量" required>
          <input v-model="detail.dz" type="number"/>
        </FormItem>
        <FormItem label="分享量" required>
          <input v-model="detail.fx" type="number"/>
        </FormItem>
        <FormItem label="阅读量" required>
          <input v-model="detail.yd" type="number"/>
        </FormItem>

        <FormItem label="发布时间" required>
          <DateSelect v-model="detail.time" format="yyyy-MM-dd HH:mm:ss" type="datetime"></DateSelect>
        </FormItem>

      </Form>

      <div slot="footer">
        <Button @click="modal1=false;">取消</Button>
        <Button type="primary" @click="save(false)">保存</Button>
        <Button type="success" @click="save(true)" v-if="!detail.id">保存并继续</Button>
      </div>
    </Modal>


    <Modal
        v-model="m3.modal"
        title="选择海报推荐课程"
        :mask-closable="false"
        @on-ok="save3">
      <Alert>
        1、课程只可选择未开课场次大于等于4个，并且状态是已上架；只能选择3个，若不选择，默认随机读取。<br/>
        2、推荐课程修改后海报生成功能只会读取选择的课程，若选择课程场次过期会导致海报生成功能异常，请主动定期维护。<br/>
        3、修改后5分钟内会更新海报，请耐心等待。<br/>
      </Alert>
      <Form :label-width="80">
        <FormItem label="选择课程" required>
          <Select :multiple="true" v-model="m3.cids">
            <Option v-for="item in m3.list" :label="item.PP_NAME" :value="item.PP_ID"></Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import DateSelect from '@/public/iview/DateSelect'
import JsonInput from "../common/JsonInput";
import Field from "../common/field/Field";
import UploadOne from "../../public/upload/UploadOne";

export default {
  components: {quillEditor, DateSelect, JsonInput, Field, UploadOne},
  data() {
    return {
      power: this.$storage.getSession('power'),
      model: '',//发现 or 问答
      baseUrl: '/api/article/',
      list: [],
      page: 1,
      count: 0,
      limit: 10,
      modal1: false,
      detail: {},
      serch: {
        key: '',
        type: '',
        fabu: '',
      },
      m2: {//修改发布天数
        modal: false,
        day: 0,
      },
      m3:{
        id:0,
        modal:false,
        list:[],
        cids:[],
      },

      loading: false,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{'color': []}],
            [{'align': []}],
            [{'list': 'ordered'}, {'list': 'bullet'}],// 值ordered，bullet
            ['image'],
          ]
        }
      },
    }
  },
  methods: {
    save3(){
      if(this.m3.cids.length>0&&this.m3.cids.length!=3){
        this.$Message.error('课程只能选择3个或不选择');
        return ;
      }
      let that = this;
      this.$axios.get('/api/article/saveCourse?id='+this.m3.id+'&cids='+this.m3.cids).then(function(rs){
        that.toast(rs.data);
      });
    },
    open3(row) {
      this.m3.id = row.id;
      this.m3.modal = true;
      let that = this;
      this.$axios.get('/api/article/getCourse').then(function (rs) {
        that.m3.list = rs.data;
      });
    },
    reload() {
      this.page = 1;
      this.load();
    },
    onEditorChange(obj) {
      this.detail.content = obj.html;
      this.detail.text = obj.text;
    },
    //给点赞和分享阅读量分别随机生成数值
    genRandom() {
      this.detail.dz = this.randomNum(5, 20);//当天的初始点赞量，默认为：5-20内的数值
      this.detail.fx = this.randomNum(1, 10);//当天的初始分享量，默认为：1-10内的数值
      this.detail.yd = this.randomNum(95, 250);//当天的初始浏览量为：95-250之间
    },

    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
          break;
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
          break;
        default:
          return 0;
          break;
      }
    },

    load() {
      let that = this;
      let params = [];
      if (this.serch.key) {
        params.push('t.title0t.content@like@' + this.serch.key);
      }
      that.loading = true;
      this.$axios.get(this.baseUrl + 'findall?page=' + this.page + '&limit=' + this.limit + '&params=' + params + '&all=true').then(function (rs) {
        that.list = rs.data.data;
        that.count = rs.data.count;
        that.loading = false;
      });
    },
    limitChange(val) {
      this.limit = val;
      this.load();
    },
    change(val) {
      this.page = val;
      this.load();
    },
    save(flag) {
      let that = this;
      if (!this.detail.fabu && this.model === '问答') {
        this.$Message.error('请告诉我怎么发布？');
        return;
      }
      this.detail.model = this.model;
      let tfenlei = this.detail.tfenlei;
      this.detail.tfenlei = null;
      let data = Object.assign({}, this.detail);
      this.$axios({
        url: this.baseUrl + 'save?tfenlei=' + tfenlei,
        method: 'post',
        data: this.$qs.stringify(data)
      }).then(function (rs) {
        that.toast(rs.data);
        if (rs.data.success) {
          if (!flag) { //提交不继续了
            that.detail = {};
            that.modal1 = false;
          } else {//提交并继续
            that.detail.id = null;
            that.detail.miaoshu = null;
            that.detail.title = null;
            that.detail.content = null;
            that.detail.zhaiyao = null;
            that.detail.chuchu = null;
            that.detail.tfenlei = tfenlei;
            that.genRandom();
          }
        }
      });
    },
    edit(id) {
      let that = this;
      this.$axios.get(this.baseUrl + 'getById2?id=' + id).then(function (rs) {
        that.detail = rs.data;
        that.modal1 = true;
      });
    },
    remove(id) {
      this.$Modal.confirm({
        title: '系统提示',
        content: '确定要删除吗',
        onOk: () => {
          let that = this;
          this.$axios.get(this.baseUrl + 'delete?ids=' + id).then(function (rs) {
            that.toast(rs.data);
          });
        },
      });
    },
    toast(data) {
      if (data.success) {
        this.load();
        this.$Message.success(data.msg);
      } else {
        this.$Message.error(data.msg);
      }
    },

    save2() {
      let that = this;
      this.$axios.get('/api/article/updatePublishFrequency?day=' + this.m2.day + "&model=" + this.model).then(function (rs) {
        that.toast(rs.data);
      });
    },
  },

  created() {
    this.load();
  },
  watch: {
    $route(to, from) {
      this.load();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/zixun/Zixun.vue